/* eslint-disable perfectionist/sort-objects */
export type OpenTimesInput = {
  days: string;
  hours: string;
}[];

export type WeeklySchedule = {
  day: string;
  time: string;
}[];

const formatTime = (time: string): string => {
  if (time.toLowerCase() === 'closed') {
    return 'Closed';
  }

  return time.replace(/:00/g, '').toLowerCase();
};

export const convertOpenTimesToWeeklySchedule = (
  data?: OpenTimesInput
): WeeklySchedule => {
  const dayMap: Record<string, string> = {
    Sun: 'Sunday',
    Mon: 'Monday',
    Tue: 'Tuesday',
    Wed: 'Wednesday',
    Thu: 'Thursday',
    Fri: 'Friday',
    Sat: 'Saturday',
  };

  const orderedDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const dayToHoursMap: Record<string, string> = {
    Sun: 'Closed',
    Mon: 'Closed',
    Tue: 'Closed',
    Wed: 'Closed',
    Thu: 'Closed',
    Fri: 'Closed',
    Sat: 'Closed',
  };

  data?.forEach((item) => {
    const [startDay, endDay] = item.days.split(' - ').map((d) => d.trim());
    let currentDayIdx = orderedDays.indexOf(startDay);
    const endDayIdx = orderedDays.indexOf(endDay);

    do {
      dayToHoursMap[orderedDays[currentDayIdx]] = formatTime(item.hours);
      currentDayIdx = (currentDayIdx + 1) % 7;
    } while (currentDayIdx !== (endDayIdx + 1) % 7);
  });

  const output: WeeklySchedule = orderedDays.map((dayShort) => ({
    day: dayMap[dayShort],
    time: dayToHoursMap[dayShort],
  }));

  return output;
};
